module.exports = __webpack_public_path__ + "static/the-fourth-turning-eeb78a017195960a5a040bb7e970bb8d.jpg";